import { IAddress } from '@app/models/Address'
import * as React from 'react'

interface IAddressBlockProps {
  address: IAddress
  className?: string
  style?: React.CSSProperties
}

export default class AddressBlock extends React.PureComponent<
  IAddressBlockProps
> {
  public render() {
    return (
      <div className={this.props.className} style={this.props.style}>
        {this.props.address.attention && (
          <div>{this.props.address.attention}</div>
        )}
        <div>{this.props.address.line1}</div>
        {this.props.address.line2 && <div>{this.props.address.line2}</div>}
        {(this.props.address.city ||
          this.props.address.state ||
          this.props.address.zip) && (
          <div>
            {this.props.address.city}, {this.props.address.state}{' '}
            {this.props.address.zip}
          </div>
        )}
      </div>
    )
  }
}
